import { useMemo } from 'react';

import { REGIONS } from 'state/intl/types';
import { validationConfig as validationConfigSample } from 'utils/form/user-profile-validation-config/validation';

type TValidationConfig = typeof validationConfigSample;

export const useBirthdayIsRequired = (region: REGIONS, validationConfig: TValidationConfig) => {
  const birthdayIsRequired = useMemo(() => {
    const required = validationConfig.dob.required;

    if (!required) {
      return false;
    }

    return required === true || required.locales.includes(region);
  }, [region, validationConfig]);

  return birthdayIsRequired;
};
